import { ChatBubble } from "./flowChatBubbles";
import { formatSuggestCostUsd } from "./functions";

function formatLatencySeconds(latencyMs) {
    if (latencyMs == null || !Number.isFinite(Number(latencyMs))) return "—";
    const s = Number(latencyMs) / 1000;
    if (s < 10) return `${s.toFixed(1)}s`;
    return `${Math.round(s)}s`;
}

function aggregateColumnMetrics(rows) {
    let totalCost = 0;
    let hasCost = false;
    let lastLatency = null;
    let allPass = true;
    let anyPass = false;

    for (const row of rows) {
        const c = row.usage?.cost_usd ?? row.cost_usd;
        if (Number.isFinite(Number(c))) {
            totalCost += Number(c);
            hasCost = true;
        }
        if (row.latencyMs != null) lastLatency = row.latencyMs;
        if (row.pass === false) allPass = false;
        if (row.pass === true) anyPass = true;
    }

    const costLabel = hasCost ? formatSuggestCostUsd(totalCost) ?? "—" : "—";
    const passIcon = rows.length === 0 ? "—" : allPass && anyPass ? "✓" : anyPass ? "✗" : "—";

    return {
        costLabel,
        latencyLabel: formatLatencySeconds(lastLatency),
        passIcon,
    };
}

export default function CompareColumn({
    slot,
    modelLabel,
    results = [],
    hasDiscrepancy = false,
    slotProgress = null,
    onVerMais,
}) {
    const sorted = [...results].sort((a, b) => {
        const ta = String(a.turnId || "");
        const tb = String(b.turnId || "");
        return ta.localeCompare(tb);
    });

    const metrics = aggregateColumnMetrics(sorted);
    const phase = slotProgress?.phase ? String(slotProgress.phase) : "";
    const isPending =
        slotProgress?.status === "running" &&
        (phase === "await_reply" || phase === "aguardando_resposta" || phase === "avaliando");

    return (
        <div
            className="rounded-lg border border-[#b47c06]/40 bg-gray-900/60 p-3 flex flex-col min-h-[200px]"
            data-testid={`compare-column-${slot}`}
        >
            <div className="flex items-center gap-2 mb-2">
                <h4 className="text-sm font-medium text-laranjinha truncate flex-1">
                    {modelLabel || `Slot ${slot}`}
                </h4>
                {hasDiscrepancy ? (
                    <span
                        className="rounded bg-amber-900/80 px-1.5 py-0.5 text-[10px] font-bold text-amber-100"
                        data-testid={`compare-discrepancy-badge-${slot}`}
                    >
                        ≠
                    </span>
                ) : null}
            </div>

            <div className="flex-1 space-y-1 mb-3 min-h-[120px]">
                {sorted.length === 0 && !isPending ? (
                    <p className="text-xs text-gray-500">Aguardando turnos…</p>
                ) : null}
                {sorted.map((row) => (
                    <div key={`${row.turnId}-${slot}`}>
                        {row.input ? (
                            <ChatBubble role="user" text={row.input} testId={`compare-user-${slot}-${row.turnId}`} />
                        ) : null}
                        <ChatBubble
                            role="bot"
                            text={row.output}
                            pass={row.pass}
                            testId={`compare-bot-${slot}-${row.turnId}`}
                        />
                    </div>
                ))}
                {isPending ? (
                    <ChatBubble role="pending" text="digitando…" testId={`compare-pending-${slot}`} />
                ) : null}
            </div>

            <footer
                className="border-t border-gray-700 pt-2 text-xs text-gray-300 flex items-center justify-between gap-2"
                data-testid={`compare-footer-${slot}`}
            >
                <span>
                    US$ {metrics.costLabel === "—" ? "—" : metrics.costLabel.replace(/^\$/, "")} ·{" "}
                    {metrics.latencyLabel} · {metrics.passIcon}
                </span>
                <button
                    type="button"
                    onClick={() => onVerMais?.()}
                    className="text-laranjinha hover:underline text-xs"
                    data-testid={`compare-ver-mais-${slot}`}
                >
                    Ver mais
                </button>
            </footer>
        </div>
    );
}
